import { createDecorator } from '../../instantiation/common/instantiation.js';
const IRemoteExtensionsScannerService = ( createDecorator('IRemoteExtensionsScannerService'));
export { IRemoteExtensionsScannerService };
